import { render } from "./ChangeLogPage.vue?vue&type=template&id=516951ca"
import script from "./ChangeLogPage.vue?vue&type=script&lang=js"
export * from "./ChangeLogPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__